import { createAction } from '@reduxjs/toolkit';

import {
  REGISTRATIONS_INFO_RESET,
  REGISTRATIONS_INFO_FETCH_START,
  REGISTRATIONS_INFO_FETCH_SUCCESS,
  REGISTRATIONS_INFO_FETCH_FAILURE,
  REGISTRATIONS_INFO_CREATE_START,
  REGISTRATIONS_INFO_CREATE_SUCCESS,
  REGISTRATIONS_INFO_CREATE_FAILURE,
  REGISTRATIONS_INFO_UPDATE_START,
  REGISTRATIONS_INFO_UPDATE_SUCCESS,
  REGISTRATIONS_INFO_UPDATE_FAILURE,
  REGISTRATIONS_INFO_DELETE_START,
  REGISTRATIONS_INFO_DELETE_SUCCESS,
  REGISTRATIONS_INFO_DELETE_FAILURE,
  REGISTRATIONS_DE_REGISTER_START,
} from './registrationsInfo.const';

export const registrationsInfoResetAction = createAction(REGISTRATIONS_INFO_RESET);

export const registrationsInfoFetchStartAction = createAction(REGISTRATIONS_INFO_FETCH_START);
export const registrationsInfoFetchSuccessAction = createAction(REGISTRATIONS_INFO_FETCH_SUCCESS);
export const registrationsInfoFetchFailureAction = createAction(REGISTRATIONS_INFO_FETCH_FAILURE);

export const registrationsInfoCreateStartAction = createAction(REGISTRATIONS_INFO_CREATE_START);
export const registrationsInfoCreateSuccessAction = createAction(REGISTRATIONS_INFO_CREATE_SUCCESS);
export const registrationsInfoCreateFailureAction = createAction(REGISTRATIONS_INFO_CREATE_FAILURE);

export const registrationsInfoUpdateStartAction = createAction(REGISTRATIONS_INFO_UPDATE_START);
export const registrationsInfoUpdateSuccessAction = createAction(REGISTRATIONS_INFO_UPDATE_SUCCESS);
export const registrationsInfoUpdateFailureAction = createAction(REGISTRATIONS_INFO_UPDATE_FAILURE);

export const registrationsInfoDeleteStartAction = createAction(REGISTRATIONS_INFO_DELETE_START);
export const registrationsInfoDeleteSuccessAction = createAction(REGISTRATIONS_INFO_DELETE_SUCCESS);
export const registrationsInfoDeleteFailureAction = createAction(REGISTRATIONS_INFO_DELETE_FAILURE);

export const registrationsDeRegisterStartAction = createAction(REGISTRATIONS_DE_REGISTER_START);
